import { render, staticRenderFns } from "./sggl.vue?vue&type=template&id=8f6d487e&scoped=true&"
import script from "./sggl.vue?vue&type=script&lang=js&"
export * from "./sggl.vue?vue&type=script&lang=js&"
import style0 from "./sggl.vue?vue&type=style&index=0&id=8f6d487e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6d487e",
  null
  
)

export default component.exports